const EmptyList = () => {
  return <>Sin artículos</>
}

export default EmptyList